<app-dialog [disableESC]="true" [wideMode]="true" #dialog>
  @if (message) {
    <ng-container body>
      <div class="dialogcontent-wrapper">
        <div class="email-header">
          @if (message.branch) {
            <app-avatar size="medium" [name]="message.branch.name" [image]="message.branch.favicon ? message.branch.favicon : message.branch.logo"></app-avatar>
          }
          @if (!message.branch) {
            <app-avatar size="medium" [name]="'Smart Lions'" icon="mail"></app-avatar>
          }
          <div class="email-subject">
            <h4>{{message.subject}}</h4>
            <!-- <small>{{message.messageType}}</small> -->
          </div>
          <div class="email-details">
            <div class="email-date">{{message.createdAt|date:'dd/MM/yyyy HH:mm'}}</div>
            <small>{{'communication-widget.messsage-count'|translate}} {{currentMessageIndex+1}} / {{messages.length}}</small>
          </div>
        </div>
        @if (failedTesting) {
          <div class="email-body">
            <div class="email-body-content">
              <div class="dialogForm-confirmtitle">{{'communication-widget.task-failed-title'|translate}}</div>
              <div class="dialogForm-confirmsubtitle">{{'communication-widget.task-failed-text'|translate}}</div>
            </div>
          </div>
        }
        @if (!failedTesting && message.htmlBody) {
          <div class="email-body" [class.dialogcontent-scroll]="!message.article">
            @if (!hideMessageContent) {
              <div class="email-body-content"  [class.intro-message]="message.article">
                <div class="label">{{'communication-widget.messsage-label'|translate}}:</div>
                <div class="text" [innerHTML]="message.htmlBody"></div>
              </div>
            }
            @if (message.article) {
              <button type="button" class="btn small stroked" [ngClass]="hideMessageContent?'disable':'primary'" (click)="hideMessageContent = !hideMessageContent">
                @if (!hideMessageContent) {
                  <i class="material-icons">expand_less</i><span>{{'communication-widget.hide-message-btn'|translate}}</span>
                }
                @if (hideMessageContent) {
                  <i class="material-icons">expand_more</i><span>{{'communication-widget.show-message-btn'|translate}}</span>
                }</button>
              }
            </div>
          }
          @if (message.article) {
            <app-article [articleId]="message.article" [messageViewer]="true" class="messageviewer"></app-article>
          }
        </div>
      </ng-container>
    }
    @if (message) {
      <ng-container footer>
        @if (message.messageType === 'precarious') {
          <div class="switch-row inline">
            <div class="switch">
              <input type="checkbox" id="underStood" [(ngModel)]="underStood" [checked]="false" autocomplete="off" [disabled]="message.read">
              <label for="underStood">
                <div>
                  <div class="note">{{'communication-widget.understood'|translate}}</div>
                </div>
              </label>
            </div>
          </div>
        }
        @if (message.messageType !== 'precarious') {
          <button type="button" class="icon-btn plain" (click)="skipMessage()" [matTooltip]="'close'|translate" matTooltipPosition="right">arrow_back</button>
        }
        @if (!message.task) {
          <button type="button" (click)="markAsRead()" class="btn" [disabled]="!underStood && message.messageType === 'precarious'">{{(message.read?'close':'communication-widget.markasread')|translate}}</button>
        }
        @if (message.task && !failedTesting) {
          <button type="button" (click)="gotoTask()" class="btn">{{'communication-widget.go-to-task-btn'|translate}}</button>
        }
        @if (failedTesting) {
          <button type="button" class='btn accent' (click)="retryTask()">{{'communication-widget.retry-task-btn'|translate}}</button>
        }
      </ng-container>
    }
  </app-dialog>

  <app-dialog #taskDialog [wideMode]="true" [disableESC]="true">
    <ng-container body>
      <div class="dialogcontent-wrapper pt2">
        <div class="dialogcontent-scroll">

          @if (!showSummary) {
            @if (!loading) {
              <div class="form-section">
                @if (currentQuestion.description) {
                  <div class="text" [innerHTML]="currentQuestion.description"></div>
                }
                @if (currentQuestion.image) {
                  <div class="question-image">
                    @if ((currentQuestion.image|mediaType) == 'image') {
                      <img [src]="(currentQuestion.image +'?filter=thumb&width=480&height=270&mode=inset')" (click)="imageZoom = false;imageDialog.show()">
                    }
                    @if ((currentQuestion.image|mediaType) == 'video') {
                      <video [src]="currentQuestion.image" controls></video>
                    }
                  </div>
                }
                <h3 class="form-title">{{currentQuestion.name}}</h3>
                @for (item of currentQuestion.options; track item) {
                  <div class="form-row">
                    @if (currentQuestion.type =='multiple-choice') {
                      <div class="col answer">
                        <div class="radiobox-wrap">
                          <input type="radio" id="answer_{{item.id}}" [value]="item.id"  [(ngModel)]="currentQuestion.answer[0]" (ngModelChange)="setAnswer()" [disabled]="currentQuestion.feedbackMode">
                          <label for="answer_{{item.id}}">
                            <div>{{item.name}}</div>
                            @if (currentQuestion.feedbackMode && item.correct) {
                              <i class="material-icons text-success">check</i>
                            }
                            @if (currentQuestion.feedbackMode && !item.correct && item.id ==  currentQuestion.answer[0]) {
                              <i class="material-icons text-warning">close</i>
                            }
                          </label>
                        </div>
                      </div>
                    }
                    @if (currentQuestion.type =='multiple-answer') {
                      <div class="col answer">
                        <div class="checkbox-wrap" >
                          <input type="checkbox" id="answer_{{item.id}}" [(ngModel)]="item.selected" [value]="item.id" (ngModelChange)="setAnswer()" [disabled]="currentQuestion.feedbackMode">
                          <label for="answer_{{item.id}}">
                            <div>{{item.name}}</div>
                            @if (currentQuestion.feedbackMode && item.correct) {
                              <i class="material-icons text-success">check</i>
                            }
                            @if (currentQuestion.feedbackMode && !item.correct && item.selected) {
                              <i class="material-icons text-warning">close</i>
                            }
                          </label>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (currentQuestion.type == 'open') {
                  <div class="form-row">
                    <div class="col">
                      <label for="answer_open"><span i18n>{{'communication-widget.task-answer'|translate}}</span></label>
                      <textarea id="answer_open" [(ngModel)]="currentQuestion.answer[0]" (ngModelChange)="setAnswer()"></textarea>
                    </div>
                  </div>
                }
              </div>
            }
            @if (currentQuestion.feedback && currentQuestion.type != 'open') {
              <div class="form-section">
                <h3 class="form-subtitle">{{'task.feedback'|translate}}</h3>
                <div class="text" [innerHTML]="currentQuestion.feedback"></div>
              </div>
            }
          }
          @if (showSummary) {
            <div class="form-section">
              <h3 class="form-title">{{'communication-widget.task-summary-title'|translate}}</h3>
              <div class="text">{{'communication-widget.task-summary-text'|translate}}</div>
            </div>
            <div class="form-section">
              @for (item of questions; track item; let i = $index) {
                <div class="question" (click)="goToQuestion(i)">
                  <div class="highlight">{{item.name}}</div>
                  <div class="text">
                    @if (!item.answer[0]) {
                      <div class=" p1 text-warning">{{'task.no-answer'|translate}}</div>
                    }
                    @if (item.answer[0]) {
                      @if (item.type == 'multiple-choice') {
                        <ul>
                          @for (a of item.options; track a) {
                            @if (a.id == item.answer[0]) {
                              <li>{{a.name}}</li>
                            }
                          }
                        </ul>
                      }
                      @if (item.type == 'multiple-answer') {
                        <ul>
                          @for (a of item.options; track a) {
                            @if (a.selected) {
                              <li>{{a.name}}</li>
                            }
                          }
                        </ul>
                      }
                      @if (item.type == 'open') {
                        <div class="p1" [innerHTML]="item.answer[0]|n2br"></div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </ng-container>
    @if (!loading) {
      <ng-container footer>
        @if (!canGoBack) {
          <button type="button" class='btn primary stroked back-button' (click)="goBackToMessage()">{{'communication-widget.back-to-message-btn'|translate}}</button>
        }
        @if (canGoBack) {
          <button type="button" class='btn primary stroked back-button' (click)="goBack()">{{'btn.vorige'|translate}}</button>
        }
        @if (!canTurnIn) {
          <button type="button" class='btn {{ canGoNext ? "stroked primary":""}}' [disabled]="!canGoNext" (click)="goNext()">{{'btn.volgende'|translate}}
            @if (currentQuestion.position < (task.questions.length-1)) {
              {{currentQuestion.position+2}}/{{task.questions.length}}
            }
          </button>
        }
        @if (canTurnIn) {
          <button type="button" class='btn accent' (click)="markAsRead()">{{'task.turn-in'|translate}}</button>
        }
      </ng-container>
    }
  </app-dialog>


  <app-dialog #imageDialog [wideMode]="true">
    <ng-container body>
      <div class="dialogcontent-wrapper">
        <div class="dialogcontent-scroll">
          @if (((currentQuestion.image)|mediaType) == 'image') {
            <img [src]="(currentQuestion.image +'?filter=thumb&width=2560&height=1440&mode=inset')| imageToBase64 | async" class="big-question-image" [class.contain]="!imageZoom" (click)="imageZoom = !imageZoom">
          }
        </div>
      </div>
    </ng-container>
    <ng-container footer>
      <button type="button" class="icon-btn plain" (click)="imageDialog.hide()" [matTooltip]="'close'|translate" matTooltipPosition="right">arrow_back</button>
      <button type="button" class="btn accent stroked" (click)="imageDialog.hide()" [matTooltip]="'close'|translate" matTooltipPosition="right">{{'close'|translate}}</button>
    </ng-container>
  </app-dialog>
